import IFormThemeOverview from '@Shared.Angular/@types/core/contracts/queryModel/formTheme/formThemeOverview';

export function getFormThemeLastUpdatedDate(theme: IFormThemeOverview): Date {
  const lastUpdatedRaw = theme.lastUpdatedUtc;
  const rawString = lastUpdatedRaw ? `${lastUpdatedRaw}` : null;
  const dateString = rawString
    ? rawString.endsWith('Z')
      ? rawString
      : `${rawString}Z`
    : null;
  const parsedDate = dateString ? new Date(dateString) : null;
  return parsedDate && !isNaN(parsedDate.getTime()) ? parsedDate : new Date();
}